import {
  SET_SYSTEM_SETTINGS,
  UNSET_SYSTEM_SETTINGS,
} from "../constants/actionTypes";

const systemSettings = (state = {}, action) => {
  switch (action.type) {
    case SET_SYSTEM_SETTINGS: {
      const byKey = {};
      (action.data?.data || []).forEach((item) => {
        if (item?.setting_key) {
          byKey[item.setting_key] = item.setting_value;
        }
      });
      return byKey;
    }
    case UNSET_SYSTEM_SETTINGS:
      return {};
    default:
      return state;
  }
};

export default systemSettings;
